import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useVipCurrentUser = () => {
  const { vip } = useShallowEqualSelector(({ userReducer: { vip } }) => ({
    vip,
  }))
  return vip
}
